import PropTypes from "prop-types";

import { Tooltip } from "components/Tooltip";
import { KeyStatsContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { KeyStatsModalContainer, MetricInfoIcon } from "./KeyStats.styles";
import { Button } from "components/Button/index";
import { isHiddenMetric, getMetricDefinition } from "utils/strategyMetrics";

export const KeyStatsModal = ({ show, onHide, stats, getFormattedValue }) => {
  // PG-2492: hide compliance-flagged metrics (e.g. "Recommended Allocation")
  // even if a caller passes them through.
  const visibleStats = (stats || []).filter(
    (stat) => !isHiddenMetric(stat?.name)
  );

  return (
    <KeyStatsModalContainer
      className="key-stats-modal"
      headingClass="key-stats-heading"
      show={show}
      onHide={onHide}
    >
      <KeyStatsContainer>
        <div className="heading">
          <h2>Key Metrics</h2>
        </div>

        <p className="disclaimer">
          Metrics are based on backtested performance data.
        </p>

        <ul className="modal-ul">
          {visibleStats.map((data, i) => {
            const definition = getMetricDefinition(data?.name);

            return (
              <li key={i}>
                <div className="label-wrapper">
                  <span className="key text-ellipsis">
                    <span className="label">
                      {data.name}
                      {definition && (
                        <Tooltip
                          placement="auto"
                          value={definition}
                          tooltipClassName="v2-tooltip"
                        >
                          <MetricInfoIcon size={12} />
                        </Tooltip>
                      )}
                    </span>
                  </span>
                </div>
                <span className="stats">{getFormattedValue(data?.value)}</span>
              </li>
            );
          })}
        </ul>
        <div className="btn-wrapper">
          <Button onClick={onHide}>Close</Button>
        </div>
      </KeyStatsContainer>
    </KeyStatsModalContainer>
  );
};

KeyStatsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  getFormattedValue: PropTypes.func,
  stats: PropTypes.array,
};
